<template>
  <Container use-full-width>
    <div class="border-b border-grey-200">
      <div class="flex items-center justify-between gap-3 py-4">
        <NuxtLink
          :to="subItem.page.url"
          :target="$useIsExternalUrl(subItem.page.url) ? '_blank' : '_self'"
          class="font-semibold transition-colors typo-subtitle hover:text-primary-900"
        >
          {{ subItem.page.title }}

        </NuxtLink>
        <button
          v-if="subItem.children?.length"
          class="pl-5"
          :aria-label="`${$t('aria_labels.show_sub_nav_elements')} ${subItem.page.title}`"
          :aria-expanded="isDropdownOpen"
          :aria-controls="`dropdown-${subItem.page.id}`"
          type="button"
          @click="toggleDropdown"
        >
          <IconChevron class="w-7 shrink-0 transition-transform duration-300 ease-in-out" :class="{ 'rotate-180': isDropdownOpen }" />
        </button>
      </div>

      <div
        v-if="subItem.children?.length"
        :id="`dropdown-${subItem.page.id}`"
        ref="dropdownElement"
        class="relative overflow-hidden transition-[width,height] duration-500 ease-in-out"
      >
        <div ref="dropdownContentElement">
          <ul
            class="
              space-y-4 pb-8
              after:absolute after:inset-x-0 after:bottom-0 after:h-10 after:bg-gradient-to-b
              after:from-transparent after:to-white
            "
          >
            <li v-for="item in subItem.children" :key="item.page.id">
              <NuxtLink
                :to="item.page.url"
                class="transition-colors slide-right typo-subtitle hover:text-primary-900"
              >
                {{ item.page.title }}
              </NuxtLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </Container>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
defineProps({
  subItem: {
    type: Object,
    required: true,
  },
})

const isDropdownOpen = ref(false)
const dropdownElement = ref(null)
const dropdownContentElement = ref(null)

function toggleDropdown() {
  // Toggle the dropdown
  isDropdownOpen.value = !isDropdownOpen.value

  if (isDropdownOpen.value) {
    dropdownElement.value.style.height = `${dropdownContentElement.value.offsetHeight}px`
    emit('heightChange', dropdownContentElement.value.offsetHeight)
  } else {
    dropdownElement.value.style.height = 0
    emit('heightChange', -dropdownContentElement.value.offsetHeight)
  }
}

onMounted(() => {
  if (dropdownElement.value) {
    dropdownElement.value.style.height = 0
  }
})

const emit = defineEmits(['heightChange'])
</script>
